// This is the root component, all the if else condition goes here for the Qutotation Headers

// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import uuid from "react-native-uuid";
import queryString from "query-string";
import { Loader, Toastr } from "@revvsales/components";

// Components Imports
import { ConfirmationBox, UpgradePopUp } from "../../commonComponents";
import AnalysisPopup from "../DocumentApprovalPopupNew/AnalysisPopup";
import EmptySignerPopup from "../DocumentApprovalPopupNew/EmptySignerPopup";
import AddRecipientsPopup from "../DocumentApprovalPopupNew/AddRecipientsPopup";
import SignerListPopup from "../DocumentApprovalPopupNew/SignerListPopup";
import AcceptanceApproveRejectConfirmation from "../DocumentApprovalPopupNew/AcceptanceApproveRejectConfirmation";
import {
  QuotationDraftStage,
  QuotationInternalReviewStage,
  QuotationRejectedStage,
  QuotationApprovedStage,
  QuotationSignedStage,
  QuotationPrepareForSignatureStage,
  QuotationDownloadOption,
  QuotationInternalReviewOwnerStage,
  QuotationSentOwnerApproverStage,
  QuotationSentOwnerStages,
  QuotationSentSignOthersStage,
  QuotationSignedOwnerStage,
  QuotationSentAcceptorOwnerStage,
  QuotationInternalStage,
} from "./QuotationStages";
import EsignatureErrorPopup from "../QuotationTopbar/QuotationTopbarBtns/EsignatureErrorPopup";
import UploadDocument from "../QuotationTopbar/QuotationTopbarBtns/UploadDocument";
import SendToDocSignScreen from "../QuotationTopbar/QuotationTopbarBtns/SendToDocSignScreen";
import DocFormIsInvalidModal from "../DocumentApprovalPopupNew/DocFormIsInvalidModal";
import ApproveRejectConfirmation from "../DocumentApprovalPopupNew/ApproveRejectConfirmation";
import DocSharingPopup from "../QuotationTopbar/QuotationTopbarBtns/DocSharingPopup";
import DocNameEditAndContinuePopup from "../DocumentApprovalPopupNew/DocNameEditAndContinuePopup";
import DocEditFromSendToSignature from "../DocumentApprovalPopupNew/DocEditFromSendToSignature";
import DocRecipientsPopup from "../DocumentApprovalPopupNew/DocRecipientsPopup";
import DocStatusUpdatePopup from "../DocumentApprovalPopupNew/DocStatusUpdatePopup";
import AddAcceptors from "../DocumentApprovalPopupNew/AddAcceptors";
import DocAcceptanceStatusUpdate from "../DocumentApprovalPopupNew/DocAcceptanceStatusUpdate";
import DocAcceptanceAcceptedStatusUpdate from "../DocumentApprovalPopupNew/DocAcceptanceAcceptedStatusUpdate";
import DocAcceptanceRejectedStatusUpdate from "../DocumentApprovalPopupNew/DocAcceptanceRejectedStatusUpdate";
import ManageTeammatesPopup from "../SettingsWrapper/TeammatesSettings/ManageTeammatesPopup";
import SendConfirmationPopup from "../DocumentApprovalPopupNew/SendConfirmationPopup";
import PermaDisablePopup from "../DocumentApprovalPopupNew/PermaDisablePopup";
import SnapDisablePopup from "../DocumentApprovalPopupNew/SnapDisablePopup";
import SubmitDeclineConfirmation from "../DocumentApprovalPopupNew/SubmitDeclineConfirmation";
import DocSubmittedStatusUpdate from "../DocumentApprovalPopupNew/DocSubmittedStatusUpdate";
import DocDeclinedStatusUpdate from "../DocumentApprovalPopupNew/DocDeclinedStatusUpdate";
import ShowEsignLimitIncreaseRequestPopup from "../ShowEsignLimitIncreaseRequestPopup/index";
import ShowUserLimitIncreaseRequestPopup from "../ShowUserLimitIncreaseRequestPopup/index";
import EmptyStripePaymentPopup from "../DocumentApprovalPopupNew/EmptyStripePaymentPopup";
import RecordVideoPopupSender from "../DocumentApprovalPopupNew/RecordVideoPopup/RecordVideoPopupSender";
import RecordVideoPopupRecipient from "../DocumentApprovalPopupNew/RecordVideoPopup/RecordVideoPopupRecipient";

// Actions Imports
import {
  getDocInPdf,
  exportDocument,
} from "../../actions/QuoteDocuments/services";
import { fetchDocumentByDocNo } from "../../actions/QuotationActions/QuotationServices";
import { getMeterUsageService } from "../../actions/CommonActions/commonService";
import {
  fetchAndUpdateDocMeta,
  resetDocToDraft,
  cancleESignature,
  sendForSignature,
  sendForSignatureV2,
  editApprovedDocument,
  makeSendForSignatureButton,
  updateDocDetails,
  docAcceptAndSignAction,
  docAfterAccepAndSignAction,
  analyzeDoc,
  generatePermaLinkAction,
  generateSnapLinkAction,
  getPermaLinkAction,
  getSnapLinkAction,
  deletePermaLinkAction,
  fetchDocRecipientListAction,
} from "../../actions/DocumentActions";
import { UserActions } from "../../actions";
import { getInitData } from "../../actions/QuotationActions/QuotationActions";

import { getExportContent } from "../../utils/documentUtils";
import { getComponentList } from "../../utils/quotationUtils";

// Internal Imports
import { GlobalUtils, DocumentUtils, AmplitudeUtils } from "../../utils/index";
import {
  EVENTS,
  FEATURES,
  DOCUMENTS,
  LOADING_MSG,
  BILLING,
} from "../../constants";
import { USER_ROLES } from "../../constants/roleList";
import StripeButtonRemovePopup from "../DocumentApprovalPopupNew/StripeButtonRemovePopup";
import AllowCameraPopup from "../DocumentApprovalPopupNew/AllowCameraPopup";

// Declarations
const {
  handleErrorMessage,
  readDataFromLocalStorage,
  handleApiErrMsg,
} = GlobalUtils;
const { checkAcceptRejectNotes } = DocumentUtils;
const { FEATURES_NAME } = FEATURES;
const { DOCUMENT_TOASTR_MESSAGE } = DOCUMENTS;
const { amplitudeLogEvent } = AmplitudeUtils;
const { initTeammatesSettingsData } = UserActions;
const { BILLINGS_ENTITY_CONSUMPTION_POINT } = BILLING;

class QuotationTopBarV2 extends Component {
  state = {
    approvalEventUuid: "",
    showLoader: false,
    loaderMsg: "",
    showAnalysisModal: false,
    showApproveRejectConfirmation: false,
    showSubmitAndDeclineBtn: true,
    submitDeclineConfirmState: "",
    submitDeclineConfirmation: false,
    approveRejectConfirmState: "",
    showConfirmMoveToDraftPopup: false,
    showUploadDocumentModal: false,
    showDocFormIsInvalidModal: false,
    showConfirmCancleEsignPopup: false,
    docFormIsInvalidModalTitle: "",
    docFormIsInvalidModalID: "",
    docFormIsInvalidModalSubTitle: "",
    showESignErrorPopup: false,
    showShareDocumentPopup: false,
    showAddRecipientsPopup: false,
    showUploadRevisionBillingPopup: false,
    showDocNameEditAndContinueModal: false,
    showDocRecipientsModal: false,
    showDocStatusUpdateModal: false,
    showDocEditFromSendToSignatureModal: false,
    // Button Loader Flags
    showAcceptAndSignBtnLoader: false,
    showSendForSignatureBtnLoader: false,
    showEmptySignerPopup: false,
    showSignerListPopup: false,
    showConfirmationEditSignerPopup: false,
    buttonValue: null,
    acceptanceApproveRejectConfirmation: false,
    showDocAcceptanceUpdateModal: false,
    activeShare: false,
    activeSnapShare: false,
    docAcceptanceConfirmationPopup: false,
    docRejecteConfirmationPopup: false,
    showTeammatePopup: false,
    isInviteThroughEditPopup: false,
    showSendConfirmationPopup: false,
    permaLinkOffPopup: false,
    snapLinkOffPopup: false,
    docSubmittedConfirmationPopup: false,
    docDeclinedConfirmationPopup: false,
    showEsignLimitIncreaseRequestPopup: false,
    eSignCosumptionRecord: {},
    showUserConsumptionPopup: false,
    userConsumptionRecord: {},
    stripeButtonRemovePopup: false,
    showEmptyStripePaymentPopup: false,
    showConfirmationEditPaymentPopup: false,
    toggleRecordVideoPopup: false,
    attachmentID: "",
    videoThumbnail: "",
    showAllowCameraPopup: false,
    showEmailMessage: false,
    showRecordVideoPopup: false,
    hasDownloadQueryParam: false,
  };

  componentDidMount() {
    this._checkForDownloadQuery();
    this._initTeammatesData();
    this._checkESignConsumption();
    this._checkUserConsumption();
    // get doc recipient if stage !== draft
    const { docRecipientList, docStage, docID } = this.props;
    if (
      docStage !== "DRAFT" &&
      !(docRecipientList && docRecipientList.length)
    ) {
      this.props.fetchDocRecipientList(docID).catch(() => {});
    }
  }

  _checkForDownloadQuery = () => {
    const { search } = window.location;
    const queryParams = queryString.parse(search);
    if (queryParams) {
      const paramKeys = Object.keys(queryParams);
      // If download params is available & has pdf as value
      if (paramKeys.includes("download") && queryParams.download === "pdf") {
        this.setState({ hasDownloadQueryParam: true }, () => {
          this._exportDocument("pdf");
        });
      }
    }
  };

  _checkESignConsumption = () => {
    getMeterUsageService(BILLINGS_ENTITY_CONSUMPTION_POINT.E_SIGN)
      .then(res => {
        this.setState({
          eSignCosumptionRecord: res || {},
        });
      })
      .catch(error => {
        console.error(
          `getEsingConsumptionRecord => getEsingConsumptionRecord => Error : ${error}`,
        );
        Toastr.showToastr({
          type: "failure",
          message: "Oops! Failed to fetch e-sign consumption record.",
          timeout: 3000,
        });
      });
  };

  _checkUserConsumption = () => {
    getMeterUsageService(BILLINGS_ENTITY_CONSUMPTION_POINT.USER_LICENCES)
      .then(res => {
        this.setState({ userConsumptionRecord: res });
      })
      .catch(error => {
        console.error(
          `getMeterUsageService => getMeterUsageService => Error : ${error}`,
        );
        Toastr.showToastr({
          type: "failure",
          message: "Oops! Failed to fetch user consumption record.",
          timeout: 3000,
        });
      });
  };

  _initTeammatesData = () => {
    this.setState({ showLoader: true });
    this.props
      .initTeammatesSettingsData()
      .then(() => {
        this.setState({ showLoader: false });
      })
      .catch(error => {
        this.setState({ showLoader: false });
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(error),
          timeout: 3000,
        });
        console.error(`CTA => _initTeammatesData => Error :${error}`);
      });
  };

  _toggleLoader = loaderText => {
    if (loaderText) {
      this.setState({
        showLoader: true,
        loaderMsg: loaderText,
      });
    } else {
      this.setState({ showLoader: false, loaderMsg: "" });
    }
  };

  _checkDownloadQueryStringPresent = () => {
    const { search } = window.location;
    const queryParams = queryString.parse(search);
    if (queryParams) {
      const paramKeys = Object.keys(queryParams);
      // If download params is available & has pdf as value
      if (paramKeys.includes("download") && queryParams.download === "pdf") {
        return true;
      }
      return false;
    }
    return false;
  };

  _checkToggleValue = type => {
    if (type === "copyLink") {
      this.state.activeShare = !this.state.activeShare;
      this.setState({ loader: false });
      console.debug(this.state.loader);

      this._togglePopUp("copyLink");
    } else if (type === "copySnapLink") {
      this.state.activeSnapShare = !this.state.activeSnapShare;
      this.setState({ loader: false });
      console.debug(this.state.loader);

      this._togglePopUp("copySnapLink");
    }
  };

  _checkFormFields = () => {
    // if true - dont show the send confirmation popup
    const { fieldsUsed, showForm } = this.props;
    if (!fieldsUsed || !fieldsUsed.length || !showForm) {
      return true;
    }
    for (let i = 0; i < fieldsUsed.length; i += 1) {
      const element = fieldsUsed[i];
      const value = element
        ? element.value || (element.meta && element.meta.default)
        : null;
      if (!value) return false;
    }
    return true;
  };

  _handleSubmitAndDecline = value => {
    //
    this.setState({
      submitDeclineConfirmation: true,
      submitDeclineConfirmState: value,
    });
  };

  _checkIfValueIsEsing = (type, flag, value) => {
    if (value && value === "eSign") {
      getMeterUsageService(BILLINGS_ENTITY_CONSUMPTION_POINT.E_SIGN)
        .then(res => {
          this.setState({
            eSignCosumptionRecord: res,
          });
          this._togglePopUp(type, flag, value);
        })
        .catch(error => {
          console.error(
            `getEsingConsumptionRecord => getEsingConsumptionRecord => Error : ${error}`,
          );
          Toastr.showToastr({
            type: "failure",
            message: "Oops! Failed to fetch e-sign consumption record.",
            timeout: 3000,
          });
        });
    } else {
      this._togglePopUp(type, flag, value);
    }
  };

  _togglePopUp = (type, flag, value) => {
    // this is the case for user limit validation
    if (
      type === "showTeammatePopup" &&
      this.state.userConsumptionRecord.limit <=
        this.state.userConsumptionRecord.usage
    ) {
      this.setState({ showUserConsumptionPopup: true });
      return;
    }

    // this is the case for eSignature limit validation
    if (
      value === "eSign" &&
      value &&
      Object.keys(this.state.eSignCosumptionRecord).length > 0 &&
      this.state.eSignCosumptionRecord.limit <=
        this.state.eSignCosumptionRecord.usage
    ) {
      this.setState({ showEsignLimitIncreaseRequestPopup: true });
      return;
    }

    if (type === "copyLink") {
      if (this.state.activeShare === true) {
        const payload = {
          object_id: this.props.docObjectId,
          object_type: "DOC",
        };
        this.props
          .generatePermaLinkAction(payload)
          .then(() => {})
          .catch(error => {
            console.error(
              `QuotationTopBarV2 => _generatePermaLink => Error : ${error}`,
            );
            Toastr.showToastr({
              type: "failure",
              message: "Oops! Something went wrong. Please try again later.",
              timeout: 3000,
            });
            this.setState({ showAcceptAndSignBtnLoader: false });
          });
      } else {
        this.setState({ permaLinkOffPopup: true });
        // this.props
        //   .deletePermaLinkAction(this.props.docObjectId, "DOC")
        //   .then(() => {})
        //   .catch(error => {
        //     console.error(
        //       `QuotationTopBarV2 => _disablePermaLink => Error : ${error}`,
        //     );
        //     Toastr.showToastr({
        //       type: "failure",
        //       message: "Oops! Something went wrong. Please try again later.",
        //       timeout: 3000,
        //     });
        //     this.setState({ showAcceptAndSignBtnLoader: false });
        //   });
      }
    } else if (type === "copySnapLink") {
      if (this.state.activeSnapShare === true) {
        const documentSectionHTML = document.getElementsByClassName(
          "document-container",
        )[0];
        const cloneTemplate = documentSectionHTML.cloneNode(true);
        cloneTemplate
          .querySelectorAll(
            ".btn-cover-page, .doc-status-band, .doc-declined-status-band, .doc-statusband-check-wrapper, .doc-statusband-check-accepted, .doc-status-internal-check, .doc-completed-status-band, .doc-sent-status-band, .doc-esign-statusband-check, .doc-esigncompleted-status-band, .doc-rejected-status-band, .approved-status-band, .doc-status-warning-band, .documentrow-plusbuttonaddcomponent-wrapper, .canvas-options, .zoom-options, .animated, .slideinright, .document-leftbar-wrapper, .new-toggle-form, .coverpageview-header-wrapper, .custompagebreak-text, .leftbar-btn, .custom-dealtable-header, .google-sheet-label, .clause-product-name, .quotetable-placeholder, .tooltip-for-signature-update, .documentview-emptydocplaceholder-title, .documentview-emptydocplaceholder-subtitle, .documentview-emptydocplaceholder-image, .drag-button-container, .invisible-selector, .customimage-formfield-placeholder",
          )
          .forEach(item => {
            item.remove();
          });

        // If the document has background color pass the value as a data attribute via html
        if (this.props.documentBgColor) {
          cloneTemplate.firstChild.setAttribute(
            "data-doc-bg-color",
            this.props.documentBgColor,
          );
        }
        const SNAP_LINK_VERSION = process.env.REACT_APP_SNAPLINLK_VERSION
          ? process.env.REACT_APP_SNAPLINLK_VERSION.split("^")[1] ||
            process.env.REACT_APP_SNAPLINLK_VERSION
          : null;

        const css = `${
          process.env.REACT_APP_SNAPLINK_CSS_URL
        }/${SNAP_LINK_VERSION}/index.css`;

        const htmlString =
          cloneTemplate && cloneTemplate.innerHTML.length > 0
            ? cloneTemplate.innerHTML
            : "";
        const payload = {
          object_id: this.props.docObjectId,
          object_type: "DOC",
          file: `${htmlString}`,
          css,
        };
        this.props
          .generateSnapLinkAction(payload)
          .then(() => {})
          .catch(error => {
            console.error(
              `QuotationTopBarV2 => _generateSnapLink => Error : ${error}`,
            );
            Toastr.showToastr({
              type: "failure",
              message: "Oops! Something went wrong. Please try again later.",
              timeout: 3000,
            });
            this.setState({ showAcceptAndSignBtnLoader: false });
          });
      } else {
        this.setState({ snapLinkOffPopup: true });
      }
    } else if (type === "showFormModeSendAnyway") {
      if (this.props.docStage === "DRAFT") {
        if (this.state.buttonValue === "eSign") {
          const { stripePaymentDetails } = this.props;
          if (
            this._getStripeButtonCount().length &&
            ((stripePaymentDetails && !stripePaymentDetails.is_active) ||
              !stripePaymentDetails)
          ) {
            // if there is a disabled button in the doc
            this.setState({
              buttonValue: value,
              stripeButtonRemovePopup: true,
            });
          } else if (this.props.signatories) {
            const { signatories: signersList } = this.props;
            amplitudeLogEvent(EVENTS.EVENT_NAMES.ESIGN_BUTTON_CLICKED, {
              SignerCount: signersList.length,
            });
            let status = false;
            const fetchSignersList = this._fetchSignersList();
            if (
              Array.isArray(fetchSignersList) &&
              fetchSignersList.length > 0
            ) {
              status = fetchSignersList.every(
                v =>
                  v.signer_email !== "" &&
                  v.first_name !== "" &&
                  v.last_name !== "",
              );
            } else {
              status = false;
            }
            if (status) {
              this.setState({ approvalEventUuid: uuid.v4() }, () =>
                this.props
                  .analyzeDoc({
                    event: "esign_type",
                    event_id: this.state.approvalEventUuid,
                    entity: "DEAL",
                    entity_id: this.props.docID,
                  })
                  .then(response => {
                    const { Analysis } = response;
                    // Check if there is no approval required then, show the "Signer list"
                    if (Analysis && Analysis.length === 0) {
                      this.setState({
                        showSignerListPopup: true,
                        showAnalysisModal: false,
                        buttonValue: value,
                      });
                    } else {
                      this.setState({
                        showAnalysisModal: true,
                        showSignerListPopup: false,
                        buttonValue: value,
                      });
                    }
                  }),
              );
            } else {
              this.setState({
                showEmptySignerPopup: true,
                buttonValue: value,
              });
            }
          }
        } else if (this.state.buttonValue === "forAcceptance") {
          const { stripePaymentDetails } = this.props;
          if (
            this._getStripeButtonCount().length &&
            ((stripePaymentDetails && !stripePaymentDetails.is_active) ||
              !stripePaymentDetails)
          ) {
            // if there is a disabled button in the doc
            this.setState({
              buttonValue: value,
              stripeButtonRemovePopup: true,
            });
          } else {
            this.setState({ approvalEventUuid: uuid.v4() }, () =>
              this.props
                .analyzeDoc({
                  event_id: this.state.approvalEventUuid,
                  entity: "DEAL",
                  entity_id: this.props.docID,
                })
                .then(response => {
                  const { Analysis } = response;
                  // Check if there is no approval required then, show the "Signer list"
                  if (Analysis && Analysis.length === 0) {
                    // check if form fields need to be checked

                    this.setState({
                      showAnalysisModal: false,
                      addAcceptorList: true,
                      buttonValue: value,
                    });
                  } else {
                    this.setState({
                      showAnalysisModal: true,
                      showSignerListPopup: false,
                      buttonValue: value,
                    });
                  }
                }),
            );
          }
        } else if (this.state.buttonValue === "forApproval") {
          this.setState({ approvalEventUuid: uuid.v4() }, () =>
            this.props
              .analyzeDoc({
                event_id: this.state.approvalEventUuid,
                entity: "DEAL",
                entity_id: this.props.docID,
              })
              .then(response => {
                const { Analysis } = response;
                // Check if there is no approval required then, show the "Signer list"
                if (Analysis && Analysis.length === 0) {
                  // check if form fields need to be checked

                  this.setState({
                    showAnalysisModal: false,
                    showDocStatusUpdateModal: true,
                    buttonValue: value,
                  });
                } else {
                  this.setState({
                    showAnalysisModal: true,
                    showSendConfirmationPopup: false,
                    buttonValue: value,
                  });
                }
              }),
          );
        }
      } else if (this.state.buttonValue === "forAcceptance") {
        this.setState({
          showSendConfirmationPopup: false,
          addAcceptorList: true,
        });
      } else if (this.state.buttonValue === "eSign") {
        this.setState({
          showSendConfirmationPopup: false,
          showSignerListPopup: true,
        });
      }
    } else if (type === "Reject") {
      this._onApproveReject(false);
    } else if (type === "UploadBilling") {
      this.setState({ showUploadRevisionBillingPopup: true });
    } else if (type === "Upload") {
      this.setState({ showUploadDocumentModal: true });
    } else if (type === "Approve") {
      this._onApproveReject(true);
    } else if (
      type === "download" &&
      this.props.sentForSignature &&
      this.props.docStage === "COMPLETED"
    ) {
      getDocInPdf(this.props.docID)
        .then(previewContent => {
          const newBlob = new Blob([previewContent], {
            type: "application/pdf",
          });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob);
            return;
          }
          const data = window.URL.createObjectURL(newBlob);
          const link = document.createElement("a");
          link.href = data;
          link.download = `${this.props.docName}.pdf`;
          link.click();
          if (this._checkDownloadQueryStringPresent()) {
            const url = `${window.location.protocol}//${
              window.location.host
            }/documents/${this.props.docNo}`;
            window.history.replaceState({ path: url }, "", url);
          }
        })
        .catch(error => {
          console.error(error);
          Toastr.showToastr({
            type: "failure",
            message: "Download Failed",
            timeout: 3000,
          });
        });
    } else if (type === "download") {
      this._exportDocument("pdf");
    } else if (type === "acceptAndSign") {
      this._handleAcceptAndSign();
    } else if (type === "submitDecline") {
      this._handleSubmitAndDecline(value);
    } else if (
      // checks if the doc is in revision mode and with unresolved notes
      flag === true &&
      this.props.acceptRejectChanges
    ) {
      this.setState({
        showDocFormIsInvalidModal: true,
        docFormIsInvalidModalTitle: "Oops! You have missed something",
        docFormIsInvalidModalSubTitle:
          "Before moving the document to the next stage, you need to accept/reject the changes in the document.",
        docFormIsInvalidModalID: "approvalpopup-form-invalid-unresolved-notes",
      });
    } else if (type === "esign-error") {
      this.setState({ showESignErrorPopup: flag });
    } else if (type === "showSignatureMoveModal") {
      this.setState({ [type]: flag });
    } else if (
      // checks if form is invalid
      type === "showDocNameEditAndContinueModal" &&
      (value === "forApproval" && value === "esign") &&
      flag === true &&
      this.props.isDocFormValid === false &&
      this.props.showForm
    ) {
      // popup here
      this.setState({
        buttonValue: value,
        showDocFormIsInvalidModal: true,
        docFormIsInvalidModalTitle:
          "Oops! You have to fill all the form fields",
        docFormIsInvalidModalSubTitle:
          "Fill all the form fields before moving to the next stage.",
        docFormIsInvalidModalID: "approvalpopup-form-invalid-empty-fields",
      });
    } else if (
      type === "showDocNameEditAndContinueModal" &&
      this.props.docName !== "Untitled Document"
    ) {
      // popup activate
      if (value === "eSign") {
        const { stripePaymentDetails } = this.props;
        if (
          this._getStripeButtonCount().length &&
          ((stripePaymentDetails && !stripePaymentDetails.is_active) ||
            !stripePaymentDetails)
        ) {
          // if there is a disabled button in the doc
          this.setState({
            buttonValue: value,
            stripeButtonRemovePopup: true,
          });
        } else if (this.props.signatories) {
          const { signatories: signersList } = this.props;
          amplitudeLogEvent(EVENTS.EVENT_NAMES.ESIGN_BUTTON_CLICKED, {
            SignerCount: signersList.length,
          });
          let status = false;
          const fetchSignersList = this._fetchSignersList();
          if (Array.isArray(fetchSignersList) && fetchSignersList.length > 0) {
            status = fetchSignersList.every(
              v =>
                v.signer_email !== "" &&
                v.first_name !== "" &&
                v.last_name !== "",
            );
          } else {
            status = false;
          }
          if (this._checkFormFields()) {
            if (status && this._checkFormFields()) {
              this.setState({ approvalEventUuid: uuid.v4() }, () =>
                this.props
                  .analyzeDoc({
                    event: "esign_type",
                    event_id: this.state.approvalEventUuid,
                    entity: "DEAL",
                    entity_id: this.props.docID,
                  })
                  .then(response => {
                    const { Analysis } = response;
                    // Check if there is no approval required then, show the "Signer list"
                    if (Analysis && Analysis.length === 0) {
                      this.setState({
                        showSignerListPopup: true,
                        showAnalysisModal: false,
                        buttonValue: value,
                      });
                    } else {
                      this.setState({
                        showAnalysisModal: true,
                        showSignerListPopup: false,
                        buttonValue: value,
                      });
                    }
                  }),
              );
            } else {
              this.setState({
                showEmptySignerPopup: true,
                buttonValue: value,
              });
            }
          } else {
            this.setState({
              showSendConfirmationPopup: true,
              buttonValue: value,
              showAnalysisModal: false,
            });
          }
        }
      } else if (value === "forAcceptance") {
        const { stripePaymentDetails } = this.props;
        if (
          this._getStripeButtonCount().length &&
          ((stripePaymentDetails && !stripePaymentDetails.is_active) ||
            !stripePaymentDetails)
        ) {
          // if there is a disabled button in the doc
          this.setState({
            buttonValue: value,
            stripeButtonRemovePopup: true,
          });
        } else if (this._checkFormFields()) {
          this.setState({ approvalEventUuid: uuid.v4() }, () =>
            this.props
              .analyzeDoc({
                event_id: this.state.approvalEventUuid,
                entity: "DEAL",
                entity_id: this.props.docID,
              })
              .then(response => {
                const { Analysis } = response;
                // Check if there is no approval required then, show the "Signer list"
                if (Analysis && Analysis.length === 0) {
                  // check if form fields need to be checked

                  this.setState({
                    showAnalysisModal: false,
                    addAcceptorList: true,
                    buttonValue: value,
                  });
                } else {
                  this.setState({
                    showAnalysisModal: true,
                    showSignerListPopup: false,
                    buttonValue: value,
                  });
                }
              }),
          );
        } else {
          this.setState({
            showAnalysisModal: false,
            showSendConfirmationPopup: true,
            buttonValue: value,
          });
        }
      }
      // for reviewers
      else if (value === "forReviewer") {
        if (this._checkFormFields()) {
          const { stripePaymentDetails } = this.props;
          if (
            this._getStripeButtonCount().length &&
            ((stripePaymentDetails && !stripePaymentDetails.is_active) ||
              !stripePaymentDetails)
          ) {
            // if there is a disabled button in the doc
            this.setState({
              buttonValue: value,
              stripeButtonRemovePopup: true,
            });
          } else {
            this.setState({ showAddRecipientsPopup: true, buttonValue: value });
          }
        } else {
          // show form field confirmation if its not true
          this.setState({
            showSendConfirmationPopup: true,
            buttonValue: value,
          });
        }
      } else if (value === "forApproval") {
        if (this._checkFormFields()) {
          const { stripePaymentDetails } = this.props;
          if (
            this._getStripeButtonCount().length &&
            ((stripePaymentDetails && !stripePaymentDetails.is_active) ||
              !stripePaymentDetails)
          ) {
            // if there is a disabled button in the doc
            this.setState({
              buttonValue: value,
              stripeButtonRemovePopup: true,
            });
          } else {
            this.setState({ showAnalysisModal: true, buttonValue: value });
          }
        } else {
          // show form field confirmation if its not true
          this.setState({
            showSendConfirmationPopup: true,
            buttonValue: value,
          });
        }
      } else if (value === "stripePayment") {
        const { stripePaymentDetails } = this.props;
        if (
          this._getStripeButtonCount().length &&
          ((stripePaymentDetails && !stripePaymentDetails.is_active) ||
            !stripePaymentDetails)
        ) {
          // if there is a disabled button in the doc
          this.setState({
            buttonValue: value,
            stripeButtonRemovePopup: true,
          });
        } else if (this._getStripeButtonCount().length === 0) {
          this.setState({
            buttonValue: value,
            showEmptyStripePaymentPopup: true,
          });
        } else {
          this.setState({
            showAddRecipientsPopup: true,
          });
        }
      }
    } else if (type === "showDocNameEditAndContinueModal") {
      if (value === "eSign") {
        const signersList = this._fetchSignersList();
        amplitudeLogEvent(EVENTS.EVENT_NAMES.ESIGN_BUTTON_CLICKED, {
          SignerCount: signersList.length,
        });
      }
      this.setState({
        showDocNameEditAndContinueModal: true,
        buttonValue: value,
      });
    } else if (type === "signerDetails") {
      const signersList = this._fetchSignersList();
      if (this.props.signatories) {
        amplitudeLogEvent(EVENTS.EVENT_NAMES.ESIGN_BUTTON_CLICKED, {
          SignerCount: this.props.signatories.length,
        });
        let status = true;
        if (Array.isArray(signersList) && signersList.length > 0) {
          status = signersList.every(
            v =>
              v.signer_email !== "" &&
              v.first_name !== "" &&
              v.last_name !== "",
          );
        } else {
          status = false;
        }
        if (status) {
          if (this._checkFormFields()) {
            this.setState({ showSignerListPopup: true, buttonValue: value });
          } else {
            this.setState({
              showSendConfirmationPopup: true,
              buttonValue: value,
            });
          }
        } else {
          this.setState({
            showConfirmationEditSignerPopup: true,
            buttonValue: value,
          });
        }
      }
    } else if (type === "checkPaymentButtons") {
      const { stripePaymentDetails } = this.props;
      if (
        this._getStripeButtonCount().length &&
        ((stripePaymentDetails && !stripePaymentDetails.is_active) ||
          !stripePaymentDetails)
      ) {
        // if there is a disabled button in the doc
        this.setState({
          buttonValue: value,
          showConfirmationEditPaymentPopup: true,
        });
      } else if (this._getStripeButtonCount().length === 0) {
        this.setState({
          buttonValue: value,
          showConfirmationEditPaymentPopup: true,
        });
      } else {
        this.setState({
          showAddRecipientsPopup: true,
        });
      }
    } else {
      // if (
      //   value === "forAcceptance" &&
      //   !this._checkFormFields() &&
      //   this.props.docStage !== "DECLINED"
      // ) {
      //   this.setState({
      //     showAnalysisModal: false,
      //     showSendConfirmationPopup: true,
      //     buttonValue: value,
      //   });
      //   return;
      // }
      if (
        (value === "forAcceptance" || value === "forReviewer") &&
        !this._checkFormFields() &&
        this.props.docStage === "DECLINED"
      ) {
        this.setState({
          showAnalysisModal: false,
          showAddRecipientsPopup: true,
          buttonValue: value,
        });
      }
      this.setState({ [type]: flag, buttonValue: value });
    }
  };

  _getOrderedSignersList = () => {
    const { signatories, layout } = this.props;

    if (Array.isArray(layout) && layout.length !== 0) {
      const componentList = getComponentList(layout);
      const signersList = [];
      componentList.forEach(componentId => {
        const signatureBlock = signatories.find(
          sig => sig.component_id === componentId,
        );
        if (signatureBlock) {
          const { signers } = signatureBlock;
          if (Array.isArray(signers) && signers.length > 0) {
            signers.forEach(signer => {
              if (
                signer.signer_email !== undefined &&
                signersList.find(s => s.signer_email === signer.signer_email)
              ) {
                const index = signersList.findIndex(
                  s => s.signer_email === signer.signer_email,
                );
                signersList[index].occurences = [
                  ...signersList[index].occurences,
                  componentId,
                ];
              } else {
                signersList.push({
                  ...signer,
                  occurences: [componentId],
                });
              }
            });
          }
        }
      });
      return signersList;
    }
    if (!Array.isArray(layout) || layout.length === 0) {
      // this is for pdf document
      // const signersList = signatories.sort((signer1, signer2) => {
      //   const { point: point1 } = signer1.signers.signer_config.point;
      //   const { point: point2 } = signer2.signers.signer_config.point;
      //   // check page number
      //   if (point1.page !== point2.page) {
      //     return point1.page - point2.page;
      //   }
      //   return point1.y !== point2.y
      //     ? point1.y - point2.y
      //     : point1.x - point2.x;
      // });

      // return signersList;
      const signersDict = {};
      signatories.forEach(signatureBlock => {
        const { component_id: componentId, signers } = signatureBlock;
        if (Array.isArray(signers) && signers.length > 0) {
          signers.forEach(signer => {
            if (
              signer.signer_email !== undefined &&
              signersDict[signer.signer_email]
            ) {
              signersDict[signer.signer_email] = {
                ...signersDict[signer.signer_email],
                occurences: [
                  ...signersDict[signer.signer_email].occurences,
                  componentId,
                ],
              };
            } else {
              signersDict[signer.signer_email] = {
                ...signer,
                occurences: [componentId],
              };
            }
          });
        }
      });
      const signersList = Object.values(signersDict);
      return signersList;
    }

    return signatories;
  };

  _fetchSignersList = () => {
    const signersList = this._getOrderedSignersList();
    return signersList;
  };

  _handleAcceptAndSign = () => {
    const { docID, docRecipientList } = this.props;
    let signer = null;
    if (docRecipientList && docRecipientList.length > 0) {
      const currentUser = readDataFromLocalStorage("revvsalesUser");
      if (currentUser && currentUser.id) {
        signer = docRecipientList.find(
          recp => recp.user && recp.user.id === currentUser.id,
        );
      }
    }

    let sharingHash = null;
    if (signer) {
      sharingHash = signer.sharing_hash;
    }

    if (sharingHash) {
      this.setState({ showAcceptAndSignBtnLoader: true });
      this.props
        .docAfterAccepAndSignAction(docID, sharingHash)
        .then(response => {
          const { signingUrl } = response;
          this.setState({ showAcceptAndSignBtnLoader: false });
          window.open(signingUrl, "_blank");
        })
        .catch(error => {
          console.error(
            `QuotationTopBarV2 => _handleAcceptAndSign =>sharedDocAfterAccepAndSign => Error : ${error}`,
          );
          Toastr.showToastr({
            type: "failure",
            message: "Oops! Something went wrong. Please try again later.",
            timeout: 3000,
          });
          this.setState({ showAcceptAndSignBtnLoader: false });
        });
    }
  };

  _onApproveReject = isApproved => {
    if (this.props.docStage && this.props.docStage === "INTERNAL_REVIEW") {
      this.setState({
        showApproveRejectConfirmation: true,
        approveRejectConfirmState: isApproved ? "Approve" : "Reject",
      });
    } else if (this.props.docStage && this.props.docStage === "SENT") {
      this.setState({
        acceptanceApproveRejectConfirmation: true,
        approveRejectConfirmState: isApproved ? "accept" : "reject",
      });
    }
  };

  _exportDocument = docType => {
    this._toggleLoader(LOADING_MSG.DOCUMENT_DOWNLOADING);
    if (this.props.isPdfDocument) {
      window.open(this.props.pdfUrl, "_blank");
      this._postDocumentDownload();
    } else {
      const { document, components } = this.props;
      const documentSectionHTML = document.getElementsByClassName(
        "document-view-main-container",
      )[0];
      const html =
        documentSectionHTML && documentSectionHTML.innerHTML.length > 0
          ? documentSectionHTML.innerHTML
          : "";
      const previewContent = getExportContent(document, components, html);

      const exportDoc = () => exportDocument(docType, previewContent);
      exportDoc()
        .then(response => {
          // get the file type
          const docMIMEType = "application/pdf";
          const file = new Blob([response], {
            type: docMIMEType,
          });
          if (navigator.msSaveBlob) {
            navigator.msSaveBlob(file, this.props.docName);
          } else {
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(file);
            link.setAttribute("download", this.props.docName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
          Toastr.showToastr({
            type: "success",
            message: "Your document has been downloaded successfully.",
            timeout: 3000,
          });
          this._postDocumentDownload();
        })
        .catch(error => {
          console.error(error);
          Toastr.showToastr({
            type: "failure",
            message: handleApiErrMsg(error),
            timeout: 3000,
          });
        });
    }
  };

  _postDocumentDownload = () => {
    // * IF DOWNLOAD QUERY PARAM IS PRESENT REMOVE IT BY RELOADING THE PAGE
    if (this.state.hasDownloadQueryParam) {
      const url = `${window.location.protocol}//${
        window.location.host
      }/documents/${this.props.docNo}`;
      window.history.replaceState({ path: url }, "", url);
      this.setState({
        hasDownloadQueryParam: false,
      });
    }
    this._toggleLoader();
  };

  _editDocument = docID => {
    amplitudeLogEvent(EVENTS.EVENT_NAMES.EDIT_DOCUMENT_CLICKED, {
      documentID: this.props.docID,
      templateID: this.props.templateID,
      status: this.props.documentStatus && this.props.documentStatus.name,
      tag: this.props.documentTag && this.props.documentTag.name,
    });
    // if (
    //   this.props.docStage === "APPROVED" ||
    //   this.props.docStage === "DECLINED" ||
    //   this.props.docStage === "SENT"
    // ) {
    //   this._createNewRevision(docID);
    // } else if (this.props.docApprovalStatus[0]) {
    //   if (
    //     this.props.docApprovalStatus[0].workflowStatus === "PENDING" ||
    //     this.props.docApprovalStatus[0].workflowStatus === "REJECTED"
    //   ) {
    //     this._resetDocToDraft(docID);
    //   }
    // }
    this._resetDocToDraft(docID);
  };

  _cancleEsign = docId => {
    this.props
      .cancleESignature(docId)
      .then(() => {
        Toastr.showToastr({
          type: "success",
          message: DOCUMENT_TOASTR_MESSAGE.CANCEL_ONE_SPAN,
          timeout: 3000,
        });
      })
      .catch(error => {
        console.error("QuotationTopBarBtns => _cancleEsign : Error", error);
        this._togglePopUp("showConfirmCancleEsignPopup", false);
        Toastr.showToastr({
          type: "failure",
          message: "Oops! Something went wrong. Please try again later.",
          timeout: 3000,
        });
      });
  };

  // This is for edit document in "Rejected" Mode
  _resetDocToDraft = docID => {
    this.props
      .resetDocToDraft(docID)
      .then(() => {
        this._togglePopUp("showConfirmMoveToDraftPopup", false);
        this.props.fetchAndUpdateDocMeta(this.props.docNo);
        Toastr.showToastr({
          type: "success",
          message: "Document moved to Drafts successfully!",
          timeout: 3000,
        });
      })
      .catch(error => {
        console.error("QuotationTopBarBtns => _resetDocToDraft : Error", error);
        this._togglePopUp("showConfirmMoveToDraftPopup", false);
        Toastr.showToastr({
          type: "failure",
          message: "Oops! Something went wrong. Please try again later.",
          timeout: 3000,
        });
      });
  };

  _closeUploadRevisionBillingPopup = () => {
    this.setState({ showUploadRevisionBillingPopup: false });
  };

  _closeDocRecipientsPopup = () => {
    this.setState({
      showDocRecipientsModal: false,
    });
  };

  _closeEsignLimitIncreaseRequestPopup = () => {
    this.setState({
      showEsignLimitIncreaseRequestPopup: false,
    });
  };

  _closeUserLimitIncreaseRequestPopup = () => {
    this.setState({
      showUserConsumptionPopup: false,
    });
  };

  // Use this method for toggling the modals
  _toggleModalPopUp = (key, flag, value) => {
    if (
      this.state.buttonValue === "eSign" &&
      key === "showDocStatusUpdateModal"
    ) {
      getMeterUsageService(BILLINGS_ENTITY_CONSUMPTION_POINT.E_SIGN)
        .then(res => {
          if (res && res.limit <= res.usage) {
            this.setState({
              [key]: flag,
              buttonValue: value,
              showEsignLimitIncreaseRequestPopup: true,
            });
          } else {
            this.setState({
              [key]: flag,
              buttonValue: value,
            });
          }
        })
        .catch(error => {
          console.error(
            `getEsingConsumptionRecord => getEsingConsumptionRecord => Error : ${error}`,
          );
          this.setState({
            [key]: flag,
            buttonValue: value,
          });
          Toastr.showToastr({
            type: "failure",
            message: "Oops! Failed to fetch e-sign consumption record.",
            timeout: 3000,
          });
        });
    } else {
      this.setState({
        [key]: flag,
        buttonValue: value,
      });
    }
  };

  // Use this method to upate multiple state
  _updateMultipleState = obj => {
    this.setState({
      ...obj,
    });
  };

  _toggleSubmitDeclinePopup = (type, flag) => {
    if (type === "Submit") {
      this._onSubmitDecline(true);
    } else if (type === "Decline") {
      this._onSubmitDecline(false);
    } else {
      this.setState({ [type]: flag });
    }
  };

  _onSubmitDecline = isSubmitted => {
    this.setState({
      submitDeclineConfirmation: true,
      submitDeclineConfirmState: isSubmitted ? "submit" : "decline",
    });
  };

  // This is for edit document in "Customer Review (Approved)" Mode
  _createNewRevision = docID => {
    this._toggleLoader(LOADING_MSG.DOCUMENT_FOR_EDITING);
    this.props
      .editApprovedDocument(docID)
      .then(() => {
        this._togglePopUp("showConfirmMoveToDraftPopup", false);
        fetchDocumentByDocNo(this.props.docNo)
          .then(res => {
            this.props
              .getInitData(res.id, res)
              .then(() => {
                this._toggleLoader();
              })
              .catch(error => {
                Toastr.showToastr({
                  type: "failure",
                  message: handleErrorMessage(error, "document"),
                  timeout: 3000,
                });
                this._toggleLoader();
              });
          })
          .catch(error => {
            Toastr.showToastr({
              type: "failure",
              message: handleErrorMessage(error, "document"),
              timeout: 3000,
            });
            this._toggleLoader();
          });
        Toastr.showToastr({
          type: "success",
          message: "Document moved to Drafts successfully!",
          timeout: 3000,
        });
      })
      .catch(error => {
        this._toggleLoader();
        console.error("QuotationTopBarBtns => editDocument : Error", error);
        this._togglePopUp("showConfirmMoveToDraftPopup", false);
        Toastr.showToastr({
          type: "failure",
          message: "Oops! Something went wrong. Please try again later.",
          timeout: 3000,
        });
      });
  };

  _getPermaLinkData = (objectId, objectType) => {
    this.props
      .getPermaLinkAction(objectId, objectType)
      .then(() => {
        if (this.props.docPermaLink) {
          this.setState({ activeShare: true });
        }
      })
      .catch(error => {
        console.error(
          "QuotationTopBarBtns => _getPermaLinkData : Error",
          error,
        );
        Toastr.showToastr({
          type: "failure",
          message: "Oops! Something went wrong. Please try again later.",
          timeout: 3000,
        });
      });
  };

  _getSnapLinkData = (objectId, objectType) => {
    this.props
      .getSnapLinkAction(objectId, objectType)
      .then(() => {
        if (this.props.docSnapLink) {
          this.setState({ activeSnapShare: true });
        }
      })
      .catch(error => {
        console.error("QuotationTopBarBtns => _getSnapLinkData : Error", error);
        Toastr.showToastr({
          type: "failure",
          message: "Oops! Something went wrong. Please try again later.",
          timeout: 3000,
        });
      });
  };

  _userStatusRoles = () => {
    const {
      docOwnerID,
      docStage,
      docPendingApprovers,
      pendingApprovalRequired,
      docAllApprovers,
      scope,
      docRecipientList,
      acceptorsList,
    } = this.props;
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    let userStatus;
    let showStage;
    if (CURRENT_USER) {
      if (
        (CURRENT_USER.id === docOwnerID &&
          docRecipientList &&
          docRecipientList.find(
            item =>
              item.user &&
              item.user.id === docOwnerID &&
              item.recipient_type === "ACCEPTOR" &&
              item.accepting_states === "",
          )) ||
        (CURRENT_USER.id === docOwnerID &&
          acceptorsList &&
          acceptorsList.find(
            item =>
              item.user &&
              item.user.id === docOwnerID &&
              item.recipient_type === "ACCEPTOR" &&
              item.accepting_states === "",
          ))
      ) {
        userStatus = "OwnerACCEPTOR";
      } else if (
        (CURRENT_USER.id !== docOwnerID &&
          docRecipientList &&
          docRecipientList.find(
            item =>
              item.user &&
              item.user.id === CURRENT_USER.id &&
              item.recipient_type === "ACCEPTOR" &&
              item.accepting_states === "",
          ) &&
          scope.write) ||
        (CURRENT_USER.id !== docOwnerID &&
          acceptorsList &&
          acceptorsList.find(
            item =>
              item.user &&
              item.user.id === CURRENT_USER.id &&
              item.recipient_type === "ACCEPTOR" &&
              item.accepting_states === "",
          ) &&
          scope.write)
      ) {
        userStatus = "EditAcceptor";
      } else if (
        (CURRENT_USER.id !== docOwnerID &&
          docRecipientList &&
          docRecipientList.find(
            item =>
              item.user &&
              item.user.id === CURRENT_USER.id &&
              item.recipient_type === "ACCEPTOR" &&
              item.accepting_states === "",
          )) ||
        (CURRENT_USER.id !== docOwnerID &&
          acceptorsList &&
          acceptorsList.find(
            item =>
              item.user &&
              item.user.id === CURRENT_USER.id &&
              item.recipient_type === "ACCEPTOR" &&
              item.accepting_states === "",
          ))
      ) {
        userStatus = "otherAcceptor";
      } else if (
        (CURRENT_USER.id === docOwnerID &&
          docRecipientList &&
          docRecipientList.find(
            item =>
              item.user &&
              item.user.id === docOwnerID &&
              item.recipient_type === "ACCEPTOR" &&
              item.accepting_states === "REJECTED",
          )) ||
        (CURRENT_USER.id === docOwnerID &&
          acceptorsList &&
          acceptorsList.find(
            item =>
              item.user &&
              item.user.id === docOwnerID &&
              item.recipient_type === "ACCEPTOR" &&
              item.accepting_states === "REJECTED",
          ))
      ) {
        userStatus = "OwnerRejected";
      } else if (
        CURRENT_USER.id === docOwnerID &&
        docRecipientList &&
        docRecipientList.find(
          item =>
            item.user &&
            item.user.id === docOwnerID &&
            item.recipient_type === "SIGNER",
        )
      ) {
        userStatus = "OwnerSigner";
      } else if (
        CURRENT_USER.id === docOwnerID &&
        docRecipientList &&
        docRecipientList.find(
          item =>
            item.user &&
            item.user.id === docOwnerID &&
            item.recipient_type === "COLLABORATOR",
        )
      ) {
        userStatus = "OwnerReviewer";
      } else if (
        CURRENT_USER.id !== docOwnerID &&
        docRecipientList &&
        docRecipientList.find(
          item =>
            item.user &&
            item.user.id === CURRENT_USER.id &&
            item.recipient_type === "SIGNER",
        ) &&
        scope.write
      ) {
        userStatus = "EditSigner";
      } else if (
        CURRENT_USER.id !== docOwnerID &&
        docRecipientList &&
        docRecipientList.find(
          item =>
            item.user &&
            item.user.id === CURRENT_USER.id &&
            item.recipient_type === "SIGNER",
        )
      ) {
        userStatus = "OtherSigner";
      } else if (
        CURRENT_USER.id === docOwnerID &&
        docRecipientList &&
        docRecipientList.find(item => item.user && item.user.id !== docOwnerID)
      ) {
        userStatus = "OwnerNotSigner";
      } else if (
        CURRENT_USER.id === docOwnerID &&
        CURRENT_USER.roles[0].name !== USER_ROLES.ADMIN &&
        docPendingApprovers.includes(CURRENT_USER.id)
      ) {
        userStatus = "Owner";
      } else if (
        CURRENT_USER.roles[0].name === USER_ROLES.ADMIN &&
        !docPendingApprovers.includes(CURRENT_USER.id)
      ) {
        userStatus = "Admin";
      } else if (
        CURRENT_USER.roles[0].name === USER_ROLES.ADMIN &&
        (docAllApprovers && docAllApprovers.includes(CURRENT_USER.id))
      ) {
        userStatus = "AdminApprover";
      } else if (docPendingApprovers.includes(CURRENT_USER.id) && scope.write) {
        userStatus = "EditApprover";
      } else if (docPendingApprovers.includes(CURRENT_USER.id)) {
        userStatus = "Approver";
      } else {
        // eslint-disable-next-line no-lonely-if
        if (
          CURRENT_USER.id === docOwnerID &&
          CURRENT_USER.roles[0].name !== USER_ROLES.ADMIN &&
          !docPendingApprovers.includes(CURRENT_USER.id)
        ) {
          userStatus = "Owner";
        } else if (
          CURRENT_USER.roles[0].name === USER_ROLES.ADMIN &&
          !docPendingApprovers.includes(CURRENT_USER.id)
        ) {
          userStatus = "Admin";
        }
        //  else if (
        //   (docAllApprovers && docAllApprovers.includes(CURRENT_USER.id)) ||
        //   docPendingApprovers.includes(CURRENT_USER.id)
        // ) {
        //   userStatus = "Approver";
        // }
        else if (scope.write) {
          userStatus = "EditAccess";
        } else if (scope.read) {
          userStatus = "Teammate";
        } else {
          userStatus = "Follower";
        }
      }
      // Document action buttons based on document stage and users
      // -------------- "DRAFT" Stage --------------
      if (docStage === "DRAFT") {
        if (
          userStatus === "Owner" ||
          userStatus === "Admin" ||
          userStatus === "OwnerSigner" ||
          userStatus === "OwnerNotSigner" ||
          userStatus === "OwnerReviewer" ||
          userStatus === "EditAccess" ||
          userStatus === "AdminApprover" ||
          userStatus === "OwnerACCEPTOR" ||
          userStatus === "EditAcceptor" ||
          userStatus === "EditApprover"
        ) {
          showStage = (
            <QuotationDraftStage
              togglePopUp={this._checkIfValueIsEsing}
              checkToggleValue={this._checkToggleValue}
              activeShare={this.state.activeShare}
              activeSnapShare={this.state.activeSnapShare}
              getPermaLinkData={this._getPermaLinkData}
              getSnapLinkData={this._getSnapLinkData}
              // handleCopyPermaLink={this._handleCopyPermaLink}
              {...this.props}
            />
          );
        } else if (userStatus === "Approver" || userStatus === "Teammate") {
          showStage = (
            <QuotationDownloadOption
              togglePopUp={this._togglePopUp}
              {...this.props}
            />
          );
        }
      }
      // -------------- "INTERNAL_REVIEW" Stage --------------
      else if (docStage === "INTERNAL_REVIEW") {
        if (pendingApprovalRequired) {
          if (
            userStatus === "Owner" ||
            userStatus === "Admin" ||
            userStatus === "AdminApprover" ||
            userStatus === "EditApprover" ||
            userStatus === "OwnerReviewer" ||
            userStatus === "OwnerNotSigner" ||
            userStatus === "OwnerSigner"
          ) {
            showStage = (
              <QuotationInternalReviewOwnerStage
                togglePopUp={this._togglePopUp}
                checkToggleValue={this._checkToggleValue}
                activeShare={this.state.activeShare}
                getPermaLinkData={this._getPermaLinkData}
                activeSnapShare={this.state.activeSnapShare}
                getSnapLinkData={this._getSnapLinkData}
                {...this.props}
              />
            );
          } else if (userStatus === "Approver" || userStatus === "Teammate") {
            showStage = (
              <QuotationInternalReviewStage
                togglePopUp={this._togglePopUp}
                {...this.props}
              />
            );
          } else {
            showStage = (
              <QuotationDownloadOption
                togglePopUp={this._togglePopUp}
                {...this.props}
              />
            );
          }
        } else if (
          userStatus === "Admin" ||
          userStatus === "Owner" ||
          userStatus === "EditAccess" ||
          userStatus === "AdminApprover" ||
          userStatus === "OwnerNotSigner" ||
          userStatus === "OwnerReviewer"
        ) {
          showStage = (
            <QuotationInternalStage
              togglePopUp={this._togglePopUp}
              checkToggleValue={this._checkToggleValue}
              activeShare={this.state.activeShare}
              getPermaLinkData={this._getPermaLinkData}
              activeSnapShare={this.state.activeSnapShare}
              getSnapLinkData={this._getSnapLinkData}
              {...this.props}
            />
          );
        } else {
          showStage = (
            <QuotationDownloadOption
              togglePopUp={this._togglePopUp}
              checkToggleValue={this._checkToggleValue}
              activeShare={this.state.activeShare}
              getPermaLinkData={this._getPermaLinkData}
              activeSnapShare={this.state.activeSnapShare}
              getSnapLinkData={this._getSnapLinkData}
              {...this.props}
            />
          );
        }
      } else if (
        this.props.docApprovalStatus[0] &&
        this.props.docApprovalStatus[0].workflowStatus === "REJECTED" &&
        docStage === "INTERNAL_REVIEW"
      ) {
        if (
          (docPendingApprovers.includes(docOwnerID) &&
            CURRENT_USER.id === docOwnerID) ||
          (userStatus === "Owner" || userStatus === "Admin")
        ) {
          showStage = (
            <QuotationInternalStage
              data="sdcsc"
              togglePopUp={this._togglePopUp}
              checkToggleValue={this._checkToggleValue}
              activeShare={this.state.activeShare}
              getPermaLinkData={this._getPermaLinkData}
              activeSnapShare={this.state.activeSnapShare}
              getSnapLinkData={this._getSnapLinkData}
              {...this.props}
            />
          );
        } else if (userStatus === "Teammate" || userStatus === "Approver") {
          showStage = (
            <QuotationDownloadOption
              togglePopUp={this._togglePopUp}
              {...this.props}
            />
          );
        }
      }
      // -------------- "INTERNAL_APPROVED" Stage --------------
      // This is a temprary stage to show the signature iframe
      else if (docStage === "INTERNAL_APPROVED") {
        if (docRecipientList) {
          if (
            userStatus === "OwnerSigner" ||
            userStatus === "OwnerNotSigner" ||
            userStatus === "Owner" ||
            userStatus === "Admin" ||
            userStatus === "OwnerReviewer" ||
            userStatus === "EditAccess"
          ) {
            showStage = (
              <QuotationPrepareForSignatureStage
                togglePopUp={this._togglePopUp}
                showBtnLoader={this.state.showSendForSignatureBtnLoader}
                {...this.props}
              />
            );
          }
        } else if (userStatus === "Admin" || userStatus === "Owner") {
          showStage = (
            <QuotationApprovedStage
              togglePopUp={this._togglePopUp}
              {...this.props}
            />
          );
        } else {
          showStage = <QuotationDownloadOption />;
        }
      }

      // -------------- "APPROVED" Stage --------------
      else if (docStage === "APPROVED") {
        if (
          userStatus === "Admin" ||
          userStatus === "Owner" ||
          userStatus === "OwnerNotSigner" ||
          userStatus === "OwnerSigner" ||
          userStatus === "OwnerReviewer" ||
          userStatus === "EditAccess" ||
          userStatus === "EditApprover" ||
          userStatus === "AdminApprover"
        ) {
          showStage = (
            <QuotationApprovedStage
              togglePopUp={this._checkIfValueIsEsing}
              checkToggleValue={this._checkToggleValue}
              activeShare={this.state.activeShare}
              getPermaLinkData={this._getPermaLinkData}
              activeSnapShare={this.state.activeSnapShare}
              getSnapLinkData={this._getSnapLinkData}
              {...this.props}
            />
          );
        } else {
          showStage = (
            <QuotationDownloadOption
              togglePopUp={this._togglePopUp}
              {...this.props}
            />
          );
        }
      }
      // -------------- "SENT" Stage --------------
      else if (docStage === "SENT" || docStage === "SENT_FOR_FILLING") {
        if (docRecipientList || acceptorsList) {
          if (userStatus === "OwnerSigner" || userStatus === "EditSigner") {
            showStage = (
              <QuotationSentOwnerApproverStage
                togglePopUp={this._togglePopUp}
                showBtnLoader={this.state.showAcceptAndSignBtnLoader}
                checkToggleValue={this._checkToggleValue}
                activeShare={this.state.activeShare}
                getPermaLinkData={this._getPermaLinkData}
                activeSnapShare={this.state.activeSnapShare}
                getSnapLinkData={this._getSnapLinkData}
                {...this.props}
              />
            );
          } else if (userStatus === "OtherSigner") {
            showStage = (
              <QuotationSentSignOthersStage
                togglePopUp={this._togglePopUp}
                showBtnLoader={this.state.showAcceptAndSignBtnLoader}
                {...this.props}
              />
            );
          } else if (
            userStatus === "OwnerACCEPTOR" ||
            userStatus === "EditAcceptor"
          ) {
            showStage = (
              <QuotationSentAcceptorOwnerStage
                togglePopUp={this._togglePopUp}
                checkToggleValue={this._checkToggleValue}
                activeShare={this.state.activeShare}
                getPermaLinkData={this._getPermaLinkData}
                activeSnapShare={this.state.activeSnapShare}
                getSnapLinkData={this._getSnapLinkData}
                {...this.props}
              />
            );
          } else if (userStatus === "otherAcceptor") {
            showStage = (
              <QuotationInternalReviewStage
                togglePopUp={this._togglePopUp}
                {...this.props}
              />
            );
          } else if (userStatus === "OwnerRejected") {
            showStage = (
              <QuotationRejectedStage
                togglePopUp={this._togglePopUp}
                {...this.props}
              />
            );
          } else if (
            userStatus === "OwnerNotSigner" ||
            userStatus === "OwnerReviewer" ||
            userStatus === "Admin" ||
            userStatus === "EditAccess"
          ) {
            showStage = (
              <QuotationSentOwnerStages
                togglePopUp={this._togglePopUp}
                checkToggleValue={this._checkToggleValue}
                activeShare={this.state.activeShare}
                getPermaLinkData={this._getPermaLinkData}
                activeSnapShare={this.state.activeSnapShare}
                getSnapLinkData={this._getSnapLinkData}
                showSubmitAndDeclineBtn={this.state.showSubmitAndDeclineBtn}
                {...this.props}
              />
            );
          } else if (userStatus === "Teammate") {
            showStage = (
              <QuotationDownloadOption
                togglePopUp={this._togglePopUp}
                {...this.props}
              />
            );
          }
        }
      }
      // -------------- "COMPLETED" Stage --------------
      else if (docStage === "COMPLETED") {
        if (
          userStatus === "Owner" ||
          userStatus === "Admin" ||
          userStatus === "EditAccess" ||
          userStatus === "OwnerNotSigner" ||
          userStatus === "OwnerReviewer" ||
          userStatus === "OwnerSigner" ||
          userStatus === "EditSigner" ||
          userStatus === "OwnerACCEPTOR" ||
          userStatus === "OwnerRejected" ||
          userStatus === "EditAcceptor"
        ) {
          showStage = (
            <QuotationSignedOwnerStage
              togglePopUp={this._togglePopUp}
              checkToggleValue={this._checkToggleValue}
              activeShare={this.state.activeShare}
              getPermaLinkData={this._getPermaLinkData}
              activeSnapShare={this.state.activeSnapShare}
              getSnapLinkData={this._getSnapLinkData}
              {...this.props}
            />
          );
        } else if (
          userStatus === "Teammate" ||
          userStatus === "Follower" ||
          userStatus === "Approver" ||
          userStatus === "OtherSigner"
        ) {
          showStage = (
            <QuotationSignedStage
              togglePopUp={this._togglePopUp}
              {...this.props}
            />
          );
        }
      }
      // -------------- "DECLINED" Stage --------------
      else if (docStage === "DECLINED") {
        if (
          userStatus === "Owner" ||
          userStatus === "Admin" ||
          userStatus === "EditAccess" ||
          userStatus === "OwnerNotSigner" ||
          userStatus === "OwnerReviewer" ||
          userStatus === "OwnerSigner" ||
          userStatus === "EditSigner" ||
          userStatus === "OwnerACCEPTOR" ||
          userStatus === "OwnerRejected" ||
          userStatus === "EditAcceptor"
        ) {
          showStage = (
            <QuotationRejectedStage
              togglePopUp={this._togglePopUp}
              checkToggleValue={this._checkToggleValue}
              activeShare={this.state.activeShare}
              getPermaLinkData={this._getPermaLinkData}
              activeSnapShare={this.state.activeSnapShare}
              getSnapLinkData={this._getSnapLinkData}
              {...this.props}
            />
          );
        } else {
          showStage = (
            <QuotationDownloadOption
              togglePopUp={this._togglePopUp}
              {...this.props}
            />
          );
        }
      }
    }

    return showStage;
  };

  _getStripeButtonCount = () => {
    // filtering all the stripe button to check while sending
    let buttonData = null;
    if (this.props.components) {
      const componentValues = Object.values(this.props.components);
      buttonData = componentValues.filter(
        elem => elem.content.type === "StripePayment",
      );
    }
    return buttonData;
  };

  render() {
    const { docID, docStatus, docName, showForm } = this.props;
    if (this.state.showLoader) {
      return <Loader label={this.state.loaderMsg} fullScreen />;
    }
    const tempSubHeader = (
      <p>
        You seem to have missed adding signer blocks or details before sending
        the document for approval. Please click{" "}
        <b>
          <i>Edit Document </i>
        </b>
        to add signature blocks or signer details and then click eSign. Your
        document may need to pass the auto-approval process again.
      </p>
    );
    // const permaHeader = (
    //   <p>
    //     If you switch off magic link, the existing link will expire. Everyone
    //     you have shared the link with will not be able to access the document
    //     anymore.
    //     <br />
    //     You can switch it on at anytime to get a new magic link for this
    //     document and reshare it with anyone.
    //   </p>
    // );
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    const user = this.props.acceptorsList.find(
      item =>
        item.user.id === CURRENT_USER.id && item.recipient_type === "ACCEPTOR",
    );

    const paymentSubHeader = (
      <div>
        <p>
          It looks like you missed adding payment blocks or did not configure
          the payment details. This document is locked because it got
          auto-approved. You can click{" "}
          <b>
            <i>Edit Document </i>
          </b>
          below to unlock it, add payment blocks or configure payment details in
          any existing blocks.
        </p>
        <p>
          Note: You cannot add a new payment block in form documents. It needs
          to be part of the original template.
        </p>
      </div>
    );

    return (
      <div>
        {this.state.permaLinkOffPopup && (
          <PermaDisablePopup
            toggleModalPopUp={this._toggleModalPopUp}
            updateMultipleState={this._updateMultipleState}
            {...this.props}
          />
        )}
        {this.state.snapLinkOffPopup && (
          <SnapDisablePopup
            toggleModalPopUp={this._toggleModalPopUp}
            updateMultipleState={this._updateMultipleState}
            {...this.props}
          />
        )}
        {this.state.docAcceptanceConfirmationPopup && (
          <DocAcceptanceAcceptedStatusUpdate
            toggleModalPopUp={this._toggleModalPopUp}
          />
        )}
        {this.state.docRejecteConfirmationPopup && (
          <DocAcceptanceRejectedStatusUpdate
            toggleModalPopUp={this._toggleModalPopUp}
          />
        )}
        {this.state.addAcceptorList && (
          <AddAcceptors
            docID={docID}
            docName={docName}
            updateMultipleState={this._updateMultipleState}
            toggleModalPopUp={this._toggleModalPopUp}
            editDocument={this._editDocument}
            closePopup={() => this._togglePopUp("addAcceptorList", false)}
            attachmentID={this.state.attachmentID}
            videoThumbnail={this.state.videoThumbnail}
            showEmailMessage={this.state.showEmailMessage}
          />
        )}
        {this.state.showAllowCameraPopup && (
          <AllowCameraPopup
            toggleModalPopUp={this._toggleModalPopUp}
            updateMultipleState={this._updateMultipleState}
          />
        )}
        {this.state.showEmptySignerPopup && (
          <EmptySignerPopup
            toggleModalPopUp={this._toggleModalPopUp}
            {...this.props}
          />
        )}
        {this.state.showSignerListPopup && (
          <SignerListPopup
            updateMultipleState={this._updateMultipleState}
            toggleModalPopUp={this._toggleModalPopUp}
            editDocument={this._editDocument}
            fetchSignersList={this._fetchSignersList()}
          />
        )}
        {/* `<b>$label</b> out of <b> ${totalDocs} </b> ($percentValue) `, */}
        {this.state.showConfirmationEditSignerPopup && (
          <ConfirmationBox
            show={this.state.showConfirmationEditSignerPopup}
            closePopup={() =>
              this._togglePopUp("showConfirmationEditSignerPopup", false)
            }
            header="🔒 Please edit this document and add signature blocks"
            subHeader={tempSubHeader}
            checkboxLabel="Edit document."
            cancelBtnText="Cancel"
            data={docID}
            confirmAction={this._editDocument}
            okBtnText="Edit document"
            disableCheckbox
            closeOnOverlayClick={false}
          />
        )}
        {this.state.showESignErrorPopup && (
          <EsignatureErrorPopup
            togglePopUp={this._togglePopUp}
            {...this.props}
          />
        )}
        {this.state.acceptanceApproveRejectConfirmation && (
          <AcceptanceApproveRejectConfirmation
            view={this.state.approveRejectConfirmState}
            togglePopUp={this._togglePopUp}
            updateMultipleState={this._updateMultipleState}
            sharingHash={user.sharing_hash}
            userDetails={user}
            senderIsAcceptor
          />
        )}
        {this.state.showApproveRejectConfirmation && (
          <ApproveRejectConfirmation
            view={this.state.approveRejectConfirmState}
            togglePopUp={this._togglePopUp}
          />
        )}
        {this.state.submitDeclineConfirmation && (
          <SubmitDeclineConfirmation
            view={this.state.submitDeclineConfirmState}
            togglePopUp={this._toggleSubmitDeclinePopup}
            updateMultipleState={this._updateMultipleState}
            isSharing={false}
          />
        )}
        {this.state.docSubmittedConfirmationPopup && (
          <DocSubmittedStatusUpdate
            toggleModalPopUp={this._toggleSubmitDeclinePopup}
          />
        )}
        {this.state.docDeclinedConfirmationPopup && (
          <DocDeclinedStatusUpdate
            toggleModalPopUp={this._toggleSubmitDeclinePopup}
          />
        )}
        {this.state.showDocNameEditAndContinueModal && (
          <DocNameEditAndContinuePopup
            fetchSignersList={this._fetchSignersList()}
            buttonValue={this.state.buttonValue}
            onClose={this._toggleModalPopUp}
            updateMultipleState={this._updateMultipleState}
            checkFormFields={this._checkFormFields}
            {...this.props}
            buttonData={this._getStripeButtonCount()}
          />
        )}
        {this.state.stripeButtonRemovePopup && (
          <StripeButtonRemovePopup
            data-test="modal-stripe"
            fetchSignersList={this._fetchSignersList()}
            buttonValue={this.state.buttonValue}
            onClose={this._toggleModalPopUp}
            updateMultipleState={this._updateMultipleState}
            checkFormFields={this._checkFormFields}
            buttonData={this._getStripeButtonCount()}
            {...this.props}
          />
        )}
        {this.state.showDocEditFromSendToSignatureModal && (
          <DocEditFromSendToSignature
            onClose={this._toggleModalPopUp}
            docID={docID}
            docName={docName}
            confirmAction={this._editDocument}
            {...this.props}
          />
        )}
        {this.state.showDocRecipientsModal && (
          <DocRecipientsPopup
            onClose={() => this._closeDocRecipientsPopup(false)}
          />
        )}
        {this.props.docStage &&
          this.props.docStage === "INTERNAL_REVIEW" &&
          this.state.showConfirmMoveToDraftPopup && (
            <ConfirmationBox
              show={this.state.showConfirmMoveToDraftPopup}
              closePopup={() =>
                this._togglePopUp("showConfirmMoveToDraftPopup", false)
              }
              header="Sure you want to edit?"
              subHeader="This document is pending approval. Editing it will retract the previously sent approval request."
              checkboxLabel="Edit document"
              cancelBtnText="Cancel"
              data={docID}
              confirmAction={this._editDocument}
              okBtnText="Edit document"
              disableCheckbox
              closeOnOverlayClick={false}
            />
          )}
        {this.props.docStage &&
          this.props.docStage === "DECLINED" &&
          this.state.showConfirmMoveToDraftPopup && (
            <ConfirmationBox
              show={this.state.showConfirmMoveToDraftPopup}
              closePopup={() =>
                this._togglePopUp("showConfirmMoveToDraftPopup", false)
              }
              header="Sure you want to edit?"
              subHeader="This document is pending approval. Editing it will retract the previously sent approval request."
              checkboxLabel="Edit document."
              cancelBtnText="Cancel"
              okBtnText="Edit document"
              disableCheckbox
              data={docID}
              confirmAction={this._editDocument}
            />
          )}
        {this.props.docStage &&
          this.props.docStage === "APPROVED" &&
          this.state.showConfirmMoveToDraftPopup && (
            <ConfirmationBox
              show={this.state.showConfirmMoveToDraftPopup}
              closePopup={() =>
                this._togglePopUp("showConfirmMoveToDraftPopup", false)
              }
              header="Sure you want to edit?"
              subHeader="This document is already approved. Editing it will nullify the previous approval workflow"
              checkboxLabel="Edit documents"
              cancelBtnText="Cancel"
              data={docID}
              okBtnText="Edit document"
              disableCheckbox
              confirmAction={this._editDocument}
              closeOnOverlayClick={false}
            />
          )}
        {this.props.docStage &&
          (this.props.docStage === "SENT" ||
            this.props.docStage === "SENT_FOR_FILLING") &&
          this.state.showConfirmMoveToDraftPopup && (
            <ConfirmationBox
              show={this.state.showConfirmMoveToDraftPopup}
              closePopup={() =>
                this._togglePopUp("showConfirmMoveToDraftPopup", false)
              }
              header="Sure you want to edit?"
              subHeader="This document has been sent for eSign or acceptance. Editing it will retract the previously sent requests and expire the shared link."
              checkboxLabel="Edit document"
              cancelBtnText="Cancel"
              data={docID}
              okBtnText="Edit document"
              disableCheckbox
              confirmAction={this._editDocument}
              closeOnOverlayClick={false}
            />
          )}
        {this.state.showUploadRevisionBillingPopup && (
          <UpgradePopUp
            featureName={FEATURES_NAME.DOCUMENTS_THIRD_PARTY_UPLOAD}
            onClose={() => this._closeUploadRevisionBillingPopup(false)}
          />
        )}
        {this.state.showConfirmCancleEsignPopup && (
          <ConfirmationBox
            show={this.state.showConfirmCancleEsignPopup}
            closePopup={() =>
              this._togglePopUp("showConfirmCancleEsignPopup", false)
            }
            header="Are you sure you want to cancel this signature?"
            subHeader="No worries, you can initiate the signature process again, when you are ready."
            checkboxLabel="Yes, I want to cancel."
            cancelBtnText="No, don't cancel"
            okBtnText="Edit document"
            disableCheckbox
            data={docID}
            confirmAction={this._cancleEsign}
          />
        )}
        {this._userStatusRoles()}
        {this.state.showAnalysisModal && (
          <AnalysisPopup toggleModalPopUp={this._togglePopUp} />
        )}
        {this.state.showAddRecipientsPopup && (
          <AddRecipientsPopup
            updateMultipleState={this._updateMultipleState}
            toggleModalPopUp={this._toggleModalPopUp}
          />
        )}
        {this.state.showSendConfirmationPopup && (
          <SendConfirmationPopup
            togglePopUp={this._togglePopUp}
            updateMultipleState={this._updateMultipleState}
            toggleModalPopUp={this._toggleModalPopUp}
            buttonValue={this.state.buttonValue}
            editDocument={this._editDocument}
            docId={this.props.docID}
            buttonData={this._getStripeButtonCount()}
            stripePaymentDetails={this.props.stripePaymentDetails}
            docStage={this.props.docStage}
            fieldsUsed={this.props.fieldsUsed}
          />
        )}
        {this.state.showDocStatusUpdateModal && (
          <DocStatusUpdatePopup
            buttonValue={this.state.buttonValue}
            docID={this.props.docID}
            documentStatus={this.props.documentStatus}
            toggleModalPopUp={this._toggleModalPopUp}
            showForm={showForm}
            docStage={this.props.docStage}
          />
        )}
        {this.state.showDocAcceptanceUpdateModal && (
          <DocAcceptanceStatusUpdate
            buttonValue={this.state.buttonValue}
            docID={this.props.docID}
            documentStatus={this.props.documentStatus}
            toggleModalPopUp={this._toggleModalPopUp}
          />
        )}
        {this.state.showSignatureMoveModal && (
          <SendToDocSignScreen
            docStatus={docStatus}
            togglePopUp={this._togglePopUp}
          />
        )}
        {this.state.showDocFormIsInvalidModal && (
          <DocFormIsInvalidModal
            togglePopUp={this._togglePopUp}
            title={this.state.docFormIsInvalidModalTitle}
            subTitle={this.state.docFormIsInvalidModalSubTitle}
            popupID={this.state.docFormIsInvalidModalID}
          />
        )}
        {this.state.showShareDocumentPopup && (
          <DocSharingPopup
            docID={docID}
            docName={docName}
            opportunity={this.props.opportunity}
            show={this.state.showShareDocumentPopup}
            closePopup={() =>
              this._togglePopUp("showShareDocumentPopup", false)
            }
          />
        )}
        {this.state.showUploadDocumentModal && (
          <UploadDocument
            show={this.state.showUploadDocumentModal}
            closePopup={() =>
              this._togglePopUp("showUploadDocumentModal", false)
            }
          />
        )}
        {this.state.showTeammatePopup && (
          <ManageTeammatesPopup
            closePopup={() => this._togglePopUp("showTeammatePopup", false)}
            updateState={this._updateMultipleState}
            roles={this.props.orgRolesList}
            teammate={{}}
            isInviteThroughEdit={this.state.isInviteThroughEditPopup}
            externalLoader={this.state.showLoader}
            isInviteFromCTA
          />
        )}
        {this.state.showUserConsumptionPopup && (
          <ShowUserLimitIncreaseRequestPopup
            userConsumptionRecord={this.state.userConsumptionRecord}
            onClose={() => this._closeUserLimitIncreaseRequestPopup()}
          />
        )}
        {this.state.showEsignLimitIncreaseRequestPopup && (
          <ShowEsignLimitIncreaseRequestPopup
            eSignCosumptionRecord={this.state.eSignCosumptionRecord}
            onClose={() => this._closeEsignLimitIncreaseRequestPopup()}
          />
        )}
        {this.state.showEmptyStripePaymentPopup && (
          <EmptyStripePaymentPopup
            toggleModalPopUp={this._toggleModalPopUp}
            {...this.props}
          />
        )}
        {this.state.showConfirmationEditPaymentPopup && (
          <ConfirmationBox
            show={this.state.showConfirmationEditPaymentPopup}
            closePopup={() =>
              this._togglePopUp("showConfirmationEditPaymentPopup", false)
            }
            header="⚠️ Edit document to add payment blocks or details"
            subHeader={paymentSubHeader}
            checkboxLabel="Edit document."
            cancelBtnText="Cancel"
            data={docID}
            confirmAction={this._editDocument}
            okBtnText="Edit document"
            disableCheckbox
            closeOnOverlayClick={false}
          />
        )}
        {this.state.toggleRecordVideoPopup && (
          <RecordVideoPopupSender
            // docID={docID}
            // docName={docName}
            updateMultipleState={this._updateMultipleState}
            toggleModalPopUp={this._toggleModalPopUp}
            closePopup={() =>
              this._togglePopUp("toggleRecordVideoPopup", false)
            }
          />
        )}
        {this.state.showRecordVideoPopup && (
          <RecordVideoPopupRecipient
            view={this.state.approveRejectConfirmState}
            updateMultipleState={this._updateMultipleState}
            senderAttachment={this.props.senderAttachment}
            videoKyc={this.props.videoKyc}
            sharingHash={user.sharing_hash}
            userDetails={user}
            isSharing={false}
            toggleModalPopUp={this._toggleModalPopUp}
            togglePopUp={this._togglePopUp}
            getUpdatedShareddata={this._getUpdatedDataValue}
            showRecordVideoPopupForRecording={
              this.state.showRecordVideoPopupForRecording
            }
          />
        )}
      </div>
    );
  }
}
const mapStateToProps = state => {
  const {
    document: {
      id: docID,
      docNo,
      name: docName,
      docType,
      isLocked,
      created_by: { id: docOwnerID, user_email: docOwnerEmail },
      opportunity,
      status: docStatus,
      stage: docStage,
      documentStatus,
      documentTag,
      showForm,
      dealTable,
      is_sent_for_signature: sentForSignature,
      template_id: templateID,
      scope,
      objectId: docObjectId,
      doc_perma_link: docPermaLink,
      doc_snap_link: docSnapLink,
      doc_snap_link_created_at: docSnapLinkCreatedAt,
      fields_used: fieldsUsed = [],
      signatories,
      isPdfDocument,
      pdfUrl,
      meta_data: metaData = {},
    } = {},
    docPendingApprovers,
    docAllApprovers,
    isDocFormValid,
    components,
    layout,
    collaboratorsData,
    pendingApprovalRequired,
    signatureEnvelopeID,
    docApprovalStatus,
    showWhoHasAccessForRecipients,
    docRecipientList,
    acceptorsList,
    stripePaymentDetails,
  } = state.DocumentStore;
  const { documentNotes } = state.NotesStore;
  const { orgRolesList } = state.SettingsStore;
  const acceptRejectChanges = checkAcceptRejectNotes(documentNotes);
  const documentBgColor = (metaData && metaData.documentBgColor) || null;
  // Pick out the required data from redux
  return {
    acceptRejectChanges,
    components,
    layout,
    dealTable,
    docAllApprovers,
    docID,
    docName,
    docNo,
    docOwnerID,
    documentStatus,
    documentTag,
    docPendingApprovers,
    docStage,
    docStatus,
    docType,
    document,
    isDocFormValid,
    isLocked,
    opportunity,
    pendingApprovalRequired,
    sentForSignature,
    showForm,
    signatureEnvelopeID,
    templateID,
    docApprovalStatus,
    scope,
    showWhoHasAccessForRecipients,
    docRecipientList,
    collaboratorsData,
    acceptorsList,
    docObjectId,
    docPermaLink,
    docSnapLink,
    docSnapLinkCreatedAt,
    orgRolesList,
    fieldsUsed,
    signatories,
    docOwnerEmail,
    isPdfDocument,
    stripePaymentDetails,
    documentBgColor,
    pdfUrl,
  };
};
const mapDispatchToProps = {
  getInitData,
  resetDocToDraft,
  fetchAndUpdateDocMeta,
  cancleESignature,
  editApprovedDocument,
  sendForSignature,
  sendForSignatureV2,
  makeSendForSignatureButton,
  updateDocDetails,
  docAcceptAndSignAction,
  docAfterAccepAndSignAction,
  generatePermaLinkAction,
  generateSnapLinkAction,
  getPermaLinkAction,
  getSnapLinkAction,
  deletePermaLinkAction,
  analyzeDoc: data => analyzeDoc(data),
  initTeammatesSettingsData,
  fetchDocRecipientList: fetchDocRecipientListAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(QuotationTopBarV2);



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV2/QuotationTopBarV2.js